import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Icons from 'components/Icons';

function Language() {
  const { language } = useParams();
  const { t } = useTranslation();

  return (
    <div>
      <div className="modal-title">
        <Icons.Language />
        <h2>{t('languageModal.title')}</h2>
      </div>
      <div className="modal-content">
        <div className="language-item">
          <div className="language-options">
            <Link to="/pt" replace>
              <div className="language-option">
                <input type="radio" checked={language === 'pt'} readOnly />
                <div className="language-option-label">Português</div>
              </div>
            </Link>
            <Link to="/en" replace>
              <div className="language-option">
                <input type="radio" checked={language === 'en'} readOnly />
                <div className="language-option-label">English</div>
              </div>
            </Link>
            <Link to="/es" replace>
              <div className="language-option">
                <input type="radio" checked={language === 'es'} readOnly />
                <div className="language-option-label">Español</div>
              </div>
            </Link>
            <Link to="/no" replace>
              <div className="language-option">
                <input type="radio" checked={language === 'no'} readOnly />
                <div className="language-option-label">Norsk</div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Language;
